import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';

import messages from '../../../locale/jsonMessages';
import InspectionPhotoGrid, { PhotoViewer } from '../../Inspection/InspectionPhotoGrid/InspectionPhotoGrid';
import ins from '../../Inspection/Inspection.css';
import s from './InspectionAdmin.css';

// Departure photos (check-in reference) next to the damage photos of the check-out, each with a zoomable viewer (R14).
export function PhotoComparison({ departure, damage }) {
  const { formatMessage } = useIntl();
  const [viewer, setViewer] = useState({ list: null, index: -1 });
  const ready = (photos) => (photos || []).map((photo) => ({ ...photo, status: 'ready' }));
  const columns = [
    { key: 'departure', title: formatMessage(messages.inspAdmPhotosDeparture), photos: ready(departure) },
    { key: 'damage', title: formatMessage(messages.inspAdmPhotosDamage), photos: ready(damage) }
  ];
  return (
    <div className={s.compare}>
      {columns.map((column) => (
        <div key={column.key}>
          <h4 className={s.compareTitle}>{column.title} ({column.photos.length})</h4>
          {column.photos.length === 0
            ? <p className={ins.cardHint}>{formatMessage(messages.inspNoPhotos)}</p>
            : <InspectionPhotoGrid items={column.photos} max={8} editable={false} title={column.title} hideCounter onViewAll={() => setViewer({ list: column.photos, index: 0 })} />}
        </div>
      ))}
      {viewer.list && <PhotoViewer photos={viewer.list} index={viewer.index} onIndex={(index) => setViewer({ list: viewer.list, index })} onClose={() => setViewer({ list: null, index: -1 })} />}
    </div>
  );
}

PhotoComparison.propTypes = { departure: PropTypes.array, damage: PropTypes.array };

export default withStyles(ins, s)(PhotoComparison);
